import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const navItems = [
  { label: '首页', href: '#top' },
  { label: '今日热议', href: '#trending' },
  { label: '话题分类', href: '#categories' },
  { label: '最新瓜料', href: '#articles' },
  { label: '瓜友交流', href: '#community' },
  { label: '常见问题', href: '#faq' },
];

export default function SiteNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [menuOpen]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70'
          : 'bg-transparent border-b border-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-8" aria-label="主导航">
        <div className="h-16 md:h-20 flex items-center justify-between gap-4">
          <Link
            to="/"
            className="flex items-center gap-2 group shrink-0"
            aria-label="黑吃瓜网 首页"
          >
            <span
              className={`w-9 h-9 flex items-center justify-center rounded-lg text-lg transition-colors ${
                scrolled
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-50/90 text-primary-600'
              }`}
            >
              <i className="ri-chat-smile-2-line" aria-hidden="true"></i>
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading font-black text-lg tracking-wide transition-colors ${
                  scrolled ? 'text-foreground-950' : 'text-background-50'
                }`}
              >
                黑吃瓜网
              </span>
              <span
                className={`text-[10px] tracking-[0.28em] mt-1 transition-colors ${
                  scrolled ? 'text-foreground-500' : 'text-background-200'
                }`}
              >
                CHIGUA CLUB
              </span>
            </span>
          </Link>

          <ul className="hidden lg:flex items-center gap-1 flex-1 justify-center">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className={`px-3 py-2 rounded-md text-sm transition-colors whitespace-nowrap ${
                    scrolled
                      ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                      : 'text-background-100 hover:text-background-50 hover:bg-background-50/10'
                  }`}
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>

          <div className="hidden md:flex items-center gap-3 shrink-0">
            <a
              href="#articles"
              aria-label="搜索瓜料"
              className={`w-9 h-9 flex items-center justify-center rounded-full transition-colors ${
                scrolled
                  ? 'text-foreground-700 hover:bg-background-100'
                  : 'text-background-50 hover:bg-background-50/10'
              }`}
            >
              <i className="ri-search-line text-lg" aria-hidden="true"></i>
            </a>
            <a
              href="#subscribe"
              className="px-4 py-2 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors whitespace-nowrap"
            >
              订阅更新
            </a>
          </div>

          <button
            type="button"
            onClick={() => setMenuOpen((v) => !v)}
            aria-label={menuOpen ? '关闭菜单' : '打开菜单'}
            aria-expanded={menuOpen}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md transition-colors ${
              scrolled || menuOpen
                ? 'text-foreground-950 hover:bg-background-100'
                : 'text-background-50 hover:bg-background-50/10'
            }`}
          >
            <i
              className={`${menuOpen ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}
              aria-hidden="true"
            ></i>
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200/70 max-h-[calc(100vh-4rem)] overflow-y-auto">
          <ul className="px-4 py-3 flex flex-col">
            {navItems.map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  onClick={() => setMenuOpen(false)}
                  className="block px-3 py-3 rounded-md text-base text-foreground-800 hover:bg-primary-50 hover:text-primary-600 transition-colors border-b border-background-100 last:border-0"
                >
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
          <div className="px-4 pb-5">
            <a
              href="#subscribe"
              onClick={() => setMenuOpen(false)}
              className="block text-center px-4 py-3 rounded-md bg-primary-500 hover:bg-primary-600 text-background-50 text-sm font-medium transition-colors"
            >
              订阅更新
            </a>
          </div>
        </div>
      )}
    </header>
  );
}